export type ImportError = { element: any; error: string };

export type StateType<T extends Object = any> = {
	syncing: boolean;
	error: string | null;
	warning: string | null;
	imported: boolean;
	response: ParseCsvFileResult<T> | null;
	errors: ImportError[];
};

export const defaultState: StateType = {
	syncing: false,
	error: null,
	warning: null,
	imported: false,
	response: null,
	errors: [],
};

type Reset = {
	type: 'Reset';
};

type SetSyncing = {
	type: 'SetSyncing';
	payload: boolean;
};

type SetImported = {
	type: 'SetImported';
	payload: boolean;
};

type SetError = {
	type: 'SetError';
	payload: string | null;
};

type SetErrors = {
	type: 'SetErrors';
	payload: ImportError[];
};

type SetWarning = {
	type: 'SetWarning';
	payload: string | null | undefined;
};

type SetResponse<T extends Object = any> = {
	type: 'SetResponse';
	payload: ParseCsvFileResult<T>;
};

type Actions = SetSyncing | Reset | SetImported | SetError | SetWarning | SetResponse | SetErrors;

export const reducer = (state: StateType, action: Actions): StateType => {
	switch (action.type) {
		case 'SetImported':
			return { ...state, imported: action.payload, error: null, syncing: false };
		case 'SetError':
			return { ...state, error: action.payload, imported: false, syncing: false };
		case 'SetErrors':
			return { ...state, errors: action.payload };
		case 'SetWarning':
			return !action.payload ? { ...state, warning: null } : { ...state, warning: action.payload };
		case 'SetSyncing':
			return { ...state, syncing: action.payload };
		case 'Reset':
			return defaultState;
		case 'SetResponse':
			return { ...state, response: action.payload };
	}
};

export function isImportErrors(data: any): data is ImportError[] {
	return (
		Array.isArray(data) && data.every((el) => !!el && typeof el.error === 'string' && typeof el.element === 'object')
	);
}
